import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  Inject,
  Optional,
  Output
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';

@Component({
  standalone: true,
  selector: 'app-modal-confirm-request',
  templateUrl: './modal-confirm-request.component.html',
  styleUrls: ['./modal-confirm-request.component.scss'],
  imports: [CommonModule, I18NextModule, MatDialogModule]
})
export class ModalConfirmRequestComponent {
  @Output() submitRequestEmitter = new EventEmitter<boolean>();

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmRequestComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  get title(): string {
    if (this.data?.titleKey) {
      return i18next.t(this.data.titleKey);
    }
    return this.data?.title || '¿Deseas continuar?';
  }

  get text(): string {
    if (this.data?.textKey) {
      return i18next.t(this.data.textKey);
    }
    return this.data?.text || '';
  }

  get paragraphs(): string[] {
    return this.data?.paragraphs || [];
  }

  get htmlContent(): string {
    if (this.data?.htmlKey) {
      return i18next.t(this.data.htmlKey);
    }
    return this.data?.htmlContent || '';
  }

  get cancelText(): string {
    return this.data?.cancelText || 'btnNo';
  }

  get confirmText(): string {
    return this.data?.confirmText || 'btnYes';
  }

  submitRequest(): void {
    this.dialogRef.close(true);
    this.submitRequestEmitter.emit(true);
  }

  closeModal(): void {
    this.dialogRef.close(false);
  }

  isI18nKey(value: string): boolean {
    return [
      'btnNo',
      'btnYes',
      'btnCancel',
      'buttonConfirm',
      'btnAccept'
    ].includes(value);
  }
}
